import React, { FC, useState } from 'react';
import { css } from '@emotion/core';

import { flexCenter, borderRadius } from '@/styles';
import { AddButton } from '@/components/primitive/actions';
import CreateEntityDrawer from '@/components/composed/create-entity-drawer/create-entity-drawer';

import { MINI_CARD_HEIGHT, LARGE_CARD_HEIGHT } from './styles';

interface IProps {
  isMini?: boolean;
}

const CreateCard: FC<IProps> = ({ isMini }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div
      css={[
        flexCenter,
        borderRadius,
        css`
          height: ${isMini ? MINI_CARD_HEIGHT : LARGE_CARD_HEIGHT}px;
        `,
      ]}
    >
      <AddButton onClick={() => setIsOpen(true)} appearance="primary">
        Create Capability SLO
      </AddButton>
      <CreateEntityDrawer isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
};

export default CreateCard;
